import { useQuery } from "@tanstack/react-query";
import { qk } from "../../lib/queryKeys";
import { getJson } from "../../lib/http";

export interface TruckYardCounts {
  yards: number;
  vehicles: number;
  groups: number;
  accessEvents: number;
  accessDevices: number;
  accessCards: number;
  guards: number;
  supervisors: number;
  inspectors: number;
  admins: number;
  // Admin de patios (#561). El backend lo agrega a COUNTERS; sin este campo el
  // badge de "Personal" sumaba cuatro tipos y la lista de abajo mostraba cinco.
  yardAdmins: number;
}

interface CountsResponse {
  data: Partial<TruckYardCounts>;
}

export function useTruckYardCounts(companyId: string | null) {
  return useQuery({
    queryKey: qk.truckYardCounts(companyId),
    queryFn: ({ signal }) =>
      getJson<CountsResponse>("/truckYardCounts", {}, { signal }).then(
        (res) => res.data ?? {},
      ),
    enabled: !!companyId,
    staleTime: 60_000,
  });
}
